module.exports = __webpack_public_path__ + "img/medal_1.7475660a.png";